import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Object$values from "@babel/runtime-corejs2/core-js/object/values";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ErrorTypes, PromotionsFlowInterface, StateTypes } from '@central-products/interface-promotions-flow';
import { Jurisdiction, Environment, RoutingStrategy } from './types';
import { loadMicroApp } from '@central-products/script-module-loader'; // tslint:disable-next-line

var noop = function noop() {};

export var PromotionsFlow = /*#__PURE__*/function (_PromotionsFlowInterf) {
  _inherits(PromotionsFlow, _PromotionsFlowInterf);

  var _super = _createSuper(PromotionsFlow);

  function PromotionsFlow(config, dependencies) {
    var _this;

    _classCallCheck(this, PromotionsFlow);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "config", void 0);

    _defineProperty(_assertThisInitialized(_this), "dependencies", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", StateTypes.STOPPED);

    _defineProperty(_assertThisInitialized(_this), "startSuccessCallback", noop);

    _defineProperty(_assertThisInitialized(_this), "startErrorCallback", noop);

    _defineProperty(_assertThisInitialized(_this), "stopSuccessCallback", noop);

    _defineProperty(_assertThisInitialized(_this), "stopErrorCallback", noop);

    _defineProperty(_assertThisInitialized(_this), "stateChangedCallback", noop);

    _defineProperty(_assertThisInitialized(_this), "viewChangedCallback", noop);

    _defineProperty(_assertThisInitialized(_this), "gameLaunchCallback", noop);

    if (!config.environment || _Object$values(Environment).indexOf(config.environment) === -1) {
      throw {
        error: ErrorTypes.MISSING_OR_INVALID_PARAM_ENVIRONMENT
      };
    }

    if (!config.jurisdiction || _Object$values(Jurisdiction).indexOf(config.jurisdiction) === -1) {
      throw {
        error: ErrorTypes.MISSING_OR_INVALID_PARAM_JURISDICTION
      };
    }

    if (!config.routingStrategy || _Object$values(RoutingStrategy).indexOf(config.routingStrategy) === -1) {
      throw {
        error: ErrorTypes.MISSING_OR_INVALID_PARAM_ROUTING_STRATEGY
      };
    }

    if (!config.helpPageUrls) {
      throw {
        error: ErrorTypes.MISSING_PARAM_HELP_PAGE_URLS
      };
    }

    if (!config.defaultLangCode) {
      throw {
        error: ErrorTypes.MISSING_PARAM_DEFAULT_LANG_CODE
      };
    }

    _this.config = config;
    _this.dependencies = dependencies;
    return _this;
  }

  _createClass(PromotionsFlow, [{
    key: "onStartSuccess",
    value: function onStartSuccess(callback) {
      this.startSuccessCallback = callback;
    }
  }, {
    key: "onStartError",
    value: function onStartError(callback) {
      this.startErrorCallback = callback;
    }
  }, {
    key: "onStopSuccess",
    value: function onStopSuccess(callback) {
      this.stopSuccessCallback = callback;
    }
  }, {
    key: "onStopError",
    value: function onStopError(callback) {
      this.stopErrorCallback = callback;
    }
  }, {
    key: "onStateChanged",
    value: function onStateChanged(callback) {
      this.stateChangedCallback = callback;
    }
  }, {
    key: "onViewChanged",
    value: function onViewChanged(callback) {
      this.viewChangedCallback = callback;
    }
  }, {
    key: "onGameLaunch",
    value: function onGameLaunch(callback) {
      this.gameLaunchCallback = callback;
    }
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var _this2 = this;

        var containerSelector, viewMode, domNode, onStartSuccess, onStartError, onStopSuccess, onStopError, onViewChanged, onGameLaunch, _this$config, jurisdiction, environment, defaultLangCode, helpPageUrls, routingStrategy, vertical, refresh, routes, gameLauncher, epicValueCarousel, microAppLoaderConfig, openResult;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                containerSelector = _ref.containerSelector, viewMode = _ref.viewMode;
                _context.prev = 1;

                if (!(this.state === StateTypes.STARTED)) {
                  _context.next = 4;
                  break;
                }

                throw {
                  error: ErrorTypes.PROMOTIONS_ALREADY_STARTED
                };

              case 4:
                if (containerSelector) {
                  _context.next = 6;
                  break;
                }

                throw {
                  error: ErrorTypes.MISSING_PARAM_CONTAINER_SELECTOR
                };

              case 6:
                domNode = document.querySelector(containerSelector);

                if (domNode) {
                  _context.next = 9;
                  break;
                }

                throw {
                  error: ErrorTypes.COULD_NOT_FIND_DOM_NODE_FOR_PROMOTIONS
                };

              case 9:
                onStartSuccess = function onStartSuccess() {
                  _this2.startSuccessCallback();
                };

                onStartError = function onStartError(error) {
                  _this2.startErrorCallback(error);
                };

                onStopSuccess = function onStopSuccess() {
                  _this2.stopSuccessCallback();
                };

                onStopError = function onStopError(error) {
                  _this2.stopErrorCallback(error);
                };

                onViewChanged = function onViewChanged(payload) {
                  _this2.viewChangedCallback(payload);
                };

                onGameLaunch = function onGameLaunch(payload) {
                  _this2.gameLaunchCallback(payload);
                };

                _this$config = this.config, jurisdiction = _this$config.jurisdiction, environment = _this$config.environment, defaultLangCode = _this$config.defaultLangCode, helpPageUrls = _this$config.helpPageUrls, routingStrategy = _this$config.routingStrategy, vertical = _this$config.vertical, refresh = _this$config.refresh, routes = _this$config.routes, gameLauncher = _this$config.gameLauncher, epicValueCarousel = _this$config.epicValueCarousel;
                microAppLoaderConfig = {
                  name: 'promotions',
                  environment: environment,
                  jurisdiction: jurisdiction,
                  dependencies: {
                    React: React,
                    ReactDOM: ReactDOM
                  }
                };
                _context.next = 19;
                return loadMicroApp(microAppLoaderConfig);

              case 19:
                openResult = window.WH['cp-apps'].promotions.open({
                  jurisdiction: jurisdiction,
                  environment: environment,
                  defaultLangCode: defaultLangCode,
                  helpPageUrls: helpPageUrls,
                  routingStrategy: routingStrategy,
                  vertical: vertical,
                  refresh: refresh,
                  routes: routes,
                  gameLauncher: gameLauncher,
                  epicValueCarousel: epicValueCarousel,
                  viewMode: viewMode,
                  graphqlClient: this.dependencies['data-access-service'],
                  dependencies: this.dependencies,
                  onOpenError: onStartError,
                  onOpenSuccess: onStartSuccess,
                  onCloseError: onStopError,
                  onCloseSuccess: onStopSuccess,
                  onViewChanged: onViewChanged,
                  onGameLaunch: onGameLaunch
                }, domNode);

                if (!(openResult === undefined)) {
                  _context.next = 22;
                  break;
                }

                throw {
                  error: ErrorTypes.PROMOTIONS_ALREADY_STARTED
                };

              case 22:
                if (!(openResult === false)) {
                  _context.next = 24;
                  break;
                }

                throw {
                  error: ErrorTypes.COULD_NOT_START_PROMOTIONS
                };

              case 24:
                this.changeState(StateTypes.STARTED);
                this.startSuccessCallback();
                return _context.abrupt("return", _Promise.resolve({}));

              case 29:
                _context.prev = 29;
                _context.t0 = _context["catch"](1);
                this.startErrorCallback(_context.t0);
                return _context.abrupt("return", _Promise.reject(_context.t0));

              case 33:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 29]]);
      }));

      function start(_x) {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var closeResult;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!(this.state === StateTypes.STOPPED)) {
                  _context2.next = 3;
                  break;
                }

                throw {
                  error: ErrorTypes.PROMOTIONS_ALREADY_STOPPED
                };

              case 3:
                closeResult = window.WH['cp-apps'].promotions.close();

                if (!(closeResult === undefined)) {
                  _context2.next = 6;
                  break;
                }

                throw {
                  error: ErrorTypes.PROMOTIONS_ALREADY_STOPPED
                };

              case 6:
                if (!(closeResult === false)) {
                  _context2.next = 8;
                  break;
                }

                throw {
                  error: ErrorTypes.COULD_NOT_STOP_PROMOTIONS
                };

              case 8:
                this.changeState(StateTypes.STOPPED);
                this.stopSuccessCallback();
                return _context2.abrupt("return", _Promise.resolve({}));

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](0);
                this.stopErrorCallback(_context2.t0);
                return _context2.abrupt("return", _Promise.reject(_context2.t0));

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 13]]);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }, {
    key: "getState",
    value: function () {
      var _getState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", _Promise.resolve({
                  state: this.state
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getState() {
        return _getState.apply(this, arguments);
      }

      return getState;
    }()
  }, {
    key: "showDetails",
    value: function () {
      var _showDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.state === StateTypes.STARTED) {
                  window.WH['cp-apps'].promotions.methods.showDetails(payload);
                }

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function showDetails(_x2) {
        return _showDetails.apply(this, arguments);
      }

      return showDetails;
    }()
  }, {
    key: "showList",
    value: function () {
      var _showList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this.state === StateTypes.STARTED) {
                  window.WH['cp-apps'].promotions.methods.showList(payload);
                }

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function showList(_x3) {
        return _showList.apply(this, arguments);
      }

      return showList;
    }()
  }, {
    key: "changeState",
    value: function changeState(state) {
      if (state !== this.state) {
        this.state = state;

        if (this.stateChangedCallback) {
          this.stateChangedCallback({
            state: state
          });
        }
      }
    }
  }]);

  return PromotionsFlow;
}(PromotionsFlowInterface);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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